package es.subastia

import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.FirebaseOptions
import dev.gitlive.firebase.initialize
import es.subastia.data.di.dataModule
import es.subastia.di.navigationModule
import es.subastia.di.viewModule
import es.subastia.navigation.NavRoute
import es.subastia.navigation.Navigator
import es.subastia.navigation.WebRouter
import kotlinx.browser.document
import kotlinx.browser.window
import org.koin.core.context.startKoin
import org.w3c.dom.events.Event

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    val options = FirebaseOptions(
        apiKey = "AIzaSyAn0XnmExabMCrWRCcWCZA2Pi5kIc_mz5M",
        projectId = "subastia-b8389",
        applicationId = "1:612192486156:web:e9d5ad9360eca0865c7f29",
        storageBucket = "subastia-b8389.firebasestorage.app",
        authDomain = "subastia-b8389.firebaseapp.com",
        gcmSenderId = "612192486156"
    )
    Firebase.initialize(options = options)

    val koinApp = startKoin {
        modules(viewModule, dataModule, navigationModule)
    }
    val navigator = koinApp.koin.get<Navigator>()

    // 1. Handle Initial Deep Link IMMEDIATELY (before Compose starts)
    // This prevents SplashScreen from even mounting if we have a deep link
    val currentPath = window.location.pathname
    val initialStack = WebRouter.fromPath(currentPath)
    if (initialStack.firstOrNull() != NavRoute.Splash || currentPath != "/") {
        navigator.replaceAll(initialStack)
    }

    ComposeViewport(document.body!!) {
        // Web Routing & Deep Linking Integration
        LaunchedEffect(Unit) {
            // 2. Listen to Browser Navigation (Back/Forward)
            val popStateListener = { _: Event ->
                val newPath = window.location.pathname
                val newStack = WebRouter.fromPath(newPath)
                navigator.replaceAll(newStack)
            }
            window.addEventListener("popstate", popStateListener)

            // 3. Sync URL with Navigation State
            navigator.backstack.collect { stack ->
                stack.lastOrNull()?.let { WebRouter.syncUrl(it) }
            }
        }

        App()
    }
}
